/* lib */
import Lenis from "lenis";
import Alpine from "alpinejs";
import Swiper from "swiper";
import { Navigation, Mousewheel, FreeMode, Autoplay, EffectFade, Thumbs, Pagination } from "swiper/modules";
import { animate, scroll, hover, transform, stagger, press, inView, frame, time } from "motion";
/* alpine components */
import alpineGallery from "./components/gallery";
/* styles */
import "swiper/css";
import "lenis/dist/lenis.css";

const lenis = new Lenis();

frame.render(({ timestamp }) => {
  lenis.raf(timestamp);
}, true);

/* easings */
const ease = [0.77, 0, 0.175, 1];
const expoOut = [0.19, 1, 0.22, 1];

if (window.matchMedia("(min-width: 768px)").matches) {
  /* pin items vertical */
  const pinCardItems = document.querySelectorAll(".app-pincards-item");
  const pinCardContainer = document.getElementById("app-pincards-container");

  if (pinCardContainer != null) {
    pinCardContainer.style.height = `${Number(pinCardContainer.dataset.postCount) * 100}vh` ?? "auto";

    const timeline = [];

    pinCardItems.forEach((item, key) => {
      if (key !== 0) {
        timeline.push([item, { y: ["100vh", 0] }]);
      }
    });

    console.log(timeline);

    scroll(animate(timeline, { ease }), { target: pinCardContainer });
  }
} else {
  /* pin items vertical */
  const pinCardItems = document.querySelectorAll(".app-pincards-item");
  const pinCardContainer = document.getElementById("app-pincards-container");

  if (pinCardContainer != null) {
    pinCardContainer.style.height = "auto";

    pinCardItems.forEach((item, key, { length }) => {
      if (key !== length - 1) {
        scroll(animate(item.querySelector(".app-pincards-item-body"), { opacity: [1, 0] }), {
          target: item,
          offset: ["end end", "end start"],
        });
      }
    });
  }
}

/* button */
hover(".app-button", (element) => {
  const shadow = element.querySelector(".app-button-shadow");
  const text = element.querySelector(".app-button-text");

  animate(
    [
      [element, { scale: 1.025 }],
      [
        shadow,
        {
          top: 0,
        },
        { at: 0 },
      ],
      [
        text,
        {
          y: "-100%",
        },
        { at: 0 },
      ],
    ],
    { duration: 0.8, ease: expoOut }
  );

  return () =>
    animate(
      [
        [element, { scale: 1 }],
        [
          shadow,
          {
            top: "100%",
          },
          { at: 0 },
        ],
        [
          text,
          {
            y: 0,
          },
          { at: 0 },
        ],
      ],
      { duration: 0.8, ease: expoOut }
    );
});

/* navigation */
let pastValue = 0;
let isScrollAnimating = false;

scroll(async (progress, { y }) => {
  const current = y.current;
  if (pastValue < current && current >= 128) {
    if (!isScrollAnimating) {
      isScrollAnimating = true;
      await animate(
        ".app-nav",
        { y: "-100%", opacity: 0 },
        {
          ease,
          onComplete: () => {
            isScrollAnimating = false;
          },
        }
      );
    }
  } else {
    if (!isScrollAnimating) {
      isScrollAnimating = true;
      animate(
        ".app-nav",
        { y: 0, opacity: 1 },
        {
          ease,
          onComplete: () => {
            isScrollAnimating = false;
          },
        }
      );
    }
  }
  pastValue = current;
});

/* menu */
const transformer = transform([1, 2], [90, 180], { clamp: false });
let isOpenMenu = false;
let rotate = 1;

hover(".app-nav-menu--close-handle", (element) => {
  const icon = element.querySelector("svg");
  animate(
    [
      [element, { scale: 1.05, backgroundColor: "#18B977" }],
      [icon, { rotate: transformer(rotate++) }, { at: 0 }],
    ],
    { ease }
  );

  return () => animate(element, { scale: 1, backgroundColor: "#ffffff" }, { ease });
});

press(".app-nav-menu--close-handle", async () => {
  if (isOpenMenu) {
    isOpenMenu = false;

    await animate([
      [".app-nav-menu", { width: 0 }, { ease, duration: 0.86 }],
      [".app-nav-menu--mobile-link span", { y: "100%" }, { at: 0, ease: "easeIn", duration: 0.24 }],
      [".app-nav-menu--link span", { y: "100%" }, { at: 0, ease: "easeIn", duration: 0.24 }],
    ]);
  }
});

press(".app-nav-menu--open-handle", async () => {
  if (!isOpenMenu) {
    isOpenMenu = true;

    await animate([
      [
        ".app-nav-menu",
        {
          width: "100%",
        },
        {
          ease,
          duration: 0.86,
        },
      ],
      [
        ".app-nav-menu--mobile-link span",
        {
          y: ["100%", 0],
        },
        { at: 0.14, delay: stagger(0.08), ease: "easeOut", duration: 0.43 },
      ],
      [
        ".app-nav-menu--link span",
        {
          y: ["100%", 0],
        },
        { at: 0.14, delay: stagger(0.08), ease: "easeOut", duration: 0.43 },
      ],
    ]);
  }
});

const media = window.matchMedia("(min-width: 640px)");
const appFrameContainer = document.getElementById("app-frame-container");
const canvas = document.getElementById("app-frame");

if (appFrameContainer != null && canvas != null) {
  const totalFrames = 122;
  const totalMobileFrames = 116;
  const baseUrl = canvas.dataset.baseUrl;

  let images = [];
  let matches = true;
  let options = { frame: 0 };

  const imageCache = {}; // Object to store cached images

  const frames = new Array(totalFrames)
    .fill()
    .map((_, index) => `${baseUrl}/assets/frames/${String(index + 1).padStart(4, "0")}.jpg`);

  const mobileFrames = new Array(totalMobileFrames)
    .fill()
    .map((_, index) => `${baseUrl}/assets/frames/mobile/${String(index + 1).padStart(4, "0")}.jpg`);

  function imageHandler(url, index) {
    if (!imageCache[url]) {
      const img = new Image();
      img.src = url;
      imageCache[url] = img;
      index || (img.onload = updateImage);
    }
    return imageCache[url];
  }

  if (media.matches !== matches) {
    matches = media.matches;
  }

  images = matches
    ? frames.map((url, index) => imageHandler(url, index))
    : mobileFrames.map((url, index) => imageHandler(url, index));

  media.addEventListener("change", () => {
    matches = media.matches;
    /* set images object */
    images = matches
      ? frames.map((url, index) => imageHandler(url, index))
      : mobileFrames.map((url, index) => imageHandler(url, index));
  });

  canvasResize();

  function drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {
    if (arguments.length === 2) {
      x = y = 0;
      w = ctx.canvas.width;
      h = ctx.canvas.height;
    }

    // default offset is center
    offsetX = typeof offsetX === "number" ? offsetX : 0.5;
    offsetY = typeof offsetY === "number" ? offsetY : 0.5;

    // keep bounds [0.0, 1.0]
    if (offsetX < 0) offsetX = 0;
    if (offsetY < 0) offsetY = 0;
    if (offsetX > 1) offsetX = 1;
    if (offsetY > 1) offsetY = 1;

    var iw = img.width,
      ih = img.height,
      r = Math.min(w / iw, h / ih),
      nw = iw * r, // new prop. width
      nh = ih * r, // new prop. height
      cx,
      cy,
      cw,
      ch,
      ar = 1;

    // decide which gap to fill
    if (nw < w) ar = w / nw;
    if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh; // updated
    nw *= ar;
    nh *= ar;

    // calc source rectangle
    cw = iw / (nw / w);
    ch = ih / (nh / h);

    cx = (iw - cw) * offsetX;
    cy = (ih - ch) * offsetY;

    // make sure source rectangle is valid
    if (cx < 0) cx = 0;
    if (cy < 0) cy = 0;
    if (cw > iw) cw = iw;
    if (ch > ih) ch = ih;

    // fill image in dest. rectangle
    ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
  }

  function updateImage() {
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.imageSmoothingEnabled = false;
    drawImageProp(context, images[options.frame], 0, 0, canvas.width, canvas.height);
  }

  function canvasResize() {
    const dpi = window.devicePixelRatio;
    const canvasHeight = getComputedStyle(canvas).getPropertyValue("height").slice(0, -2);
    const canvasWidth = getComputedStyle(canvas).getPropertyValue("width").slice(0, -2);
    //scale the canvas
    canvas.setAttribute("height", canvasHeight * dpi);
    canvas.setAttribute("width", canvasWidth * dpi);
    /* set image again */
    updateImage();
  }

  window.addEventListener("resize", canvasResize);

  scroll(
    (progress) => {
      const totalFrames = matches ? frames.length - 1 : mobileFrames.length - 1;
      const frameTransformer = transform([0, 1], [0, totalFrames]);
      const currentFrame = Math.round(frameTransformer(progress));
      if (options.frame !== currentFrame) {
        updateImage();
        options.frame = currentFrame;
      }
    },
    { target: appFrameContainer }
  );
}

/* cinta */
inView(".app-cinta", (element) => {
  animate(element, { rotate: -5, translateY: "-50%" }, { delay: 0.24 });

  return () => animate(element, { rotate: 0, translateY: "-50%" });
});

const cintaInnerContainer = document.querySelector(".app-cinta-inner");
const cintaFullWidth = cintaInnerContainer?.scrollWidth ?? 0;

if (cintaInnerContainer != null) {
  animate(cintaInnerContainer, { x: (cintaFullWidth / 2) * -1 }, { ease: "linear", duration: 20, repeat: Infinity });
}

/* history effect */
const historyItems = document.querySelectorAll(".app-history-content");

historyItems.forEach((item, key) => {
  const postId = item.dataset.historyItem;
  const imageElement = document.querySelector(`.app-history-image[data-history-item="${postId}"] img`);

  inView(
    item,
    () => {
      animate(
        imageElement,
        {
          x: [40, 0],
          opacity: [0, 1],
          scale: [0.8, 1],
        },
        { ease }
      );

      return () => animate(imageElement, { x: 40, opacity: 0, scale: 0.8 }, { ease });
    },
    { amount: "all" }
  );
});

/* clock efect */
const clockElement = document.getElementById("app-clock");

if (clockElement != null) {
  inView(clockElement, () => {
    const content = clockElement.querySelector("#app-clock-content");
    const iconTop = clockElement.querySelector("#app-clock-top");
    const iconBottom = clockElement.querySelector("#app-clock-bottom");

    animate(
      [
        [clockElement, { height: [314, "auto"], paddingTop: [0, 157], paddingBottom: [0, 157] }],
        "rotation-label",
        [iconTop, { rotate: [180, 0], translateX: ["-50%", "-50%"] }, { at: "rotation-label" }],
        [iconBottom, { rotate: [180, 0], translateX: ["-50%", "-50%"] }, { at: "rotation-label" }],
        "movement-label",
        [iconTop, { bottom: ["50%", "100%"], y: [0, 157] }, { at: "movement-label" }],
        [iconBottom, { top: ["50%", "100%"], y: [0, -157] }, { at: "movement-label" }],
        "content-label",
        [content, { opacity: [0, 1] }, { at: "content-label" }],
      ],
      { ease, duration: 2, delay: 1 }
    );

    /* descomentar en caso de que se quiera volver a animar en cuanto se quite el view */
    // return () =>
    //   animate(
    //     [
    //       [clockElement, { height: 314, paddingTop: 0, paddingBottom: 0 }],
    //       [iconTop, { rotate: 180, translateX: "-50%", bottom: "50%", y: 0 }],
    //       [iconBottom, { rotate: 180, translateX: "-50%", top: "50%", y: 0 }],
    //       [content, { opacity: 0 }],
    //     ],
    //     { ease }
    //   );
  });
}

/* swiper */
new Swiper(".swiper#testimonials", {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 20,
  breakpoints: {
    640: {
      slidesPerView: 1.5,
    },
    768: {
      slidesPerView: 2.5,
    },
    1024: {
      spaceBetween: 48,
      slidesPerView: 3.5,
    },
    1280: {
      spaceBetween: 48,
      slidesPerView: 4,
    },
  },
  // Navigation arrows
  navigation: {
    nextEl: ".app-swiper-button-next",
    prevEl: ".app-swiper-button-prev",
  },
});

new Swiper(".swiper#express, .swiper#supply, .swiper#smart", {
  modules: [Autoplay],
  loop: true,
  autoplay: {
    delay: 1000,
  },
  slidesPerView: 2,
  spaceBetween: 20,
  breakpoints: {
    640: {
      spaceBetween: 40,
      slidesPerView: 2,
    },
    768: {
      spaceBetween: 80,
      slidesPerView: 3,
    },
    1024: {
      spaceBetween: 100,
      slidesPerView: 4,
    },
    1280: {
      spaceBetween: 144,
      slidesPerView: 6,
    },
  },
});

new Swiper(".swiper#cifras", {
  modules: [EffectFade, Navigation],  
  slidesPerView: 1,
  spaceBetween: 20,
  effect: "fade",
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

new Swiper(".swiper#ruta", {
  modules: [Mousewheel, FreeMode, Autoplay],
  slideToClickedSlide: true,
  slidesPerView: 1,
  spaceBetween: 20,
  autoplay: {
    delay: 3000,
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 2.5,
    },
  },
  freeMode: {
    enabled: true,
  },
  mousewheel: {
    enabled: true,
    sensitivity: 2,
  },
  direction: "horizontal",
});

/* swiper */
new Swiper(".swiper#certificaciones", {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 40,
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
    1280: {
      slidesPerView: 4,
    },
    1536: {
      slidesPerView: 5,
    },
  },
  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

/* swiper */
var swiperss = new Swiper(".swiper#slidefront", {
  modules: [Thumbs, FreeMode ],
  loop: true,
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
});
new Swiper(".swiper#slidefront2", {
  modules: [Navigation, Thumbs, Autoplay],
  loop: true,
  spaceBetween: 10,
  autoplay: {
    delay: 7000,
  },
      navigation: {
        nextEl: ".fswiper-button-next",
        prevEl: ".fswiper-button-prev",
      },
      thumbs: {
        swiper: swiperss,
      },
});

/* swiper nosotros */
new Swiper(".swiper#slideOnline", {
  modules: [Autoplay],
  loop: true,
  autoplay: {
    delay: 2500,
  },
  slidesPerView: 1,
  spaceBetween: 20,
  breakpoints: {
    640: {
      spaceBetween: 40,
      slidesPerView: 2,
    },
    768: {
      spaceBetween: 40,
      slidesPerView: 3,
    },
    1280: {
      spaceBetween: 40,
      slidesPerView: 4,
    },
  },
});

/*bolsa de trabajo*/
new Swiper(".swiper#bolsa-i, .swiper#bolsa-c", {
  modules: [Navigation, Pagination ],  
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

jQuery(document).ready(function ($) {
  //acordion preguntas
  $(".accordion-titulo").on("click", function () {
    let contenido = $(this).next(".accordion-content");

    if (contenido.css("display") == "none") {
      //abrir
      contenido.slideDown(250);
      $(this).addClass("open");
      $(this).removeClass("border-b border-black pb-12");
      contenido.addClass("border-b border-black");
    } else {
      //cerrar
      contenido.slideUp(250);
      $(this).removeClass("open");
      $(this).addClass("border-b border-black pb-12");
      contenido.removeClass("border-b border-black");
    }
  });

  /*tabs preguntas*/
  $('div.tabs .pils:first').addClass('active');
  $('.block .contp').hide();
  $('.block .contp:first').show();
  $('div.tabs .pils').on('click',function(){
    $('div.tabs .pils').removeClass('active');
    $(this).addClass('active')
    $('.block .contp').hide();
    var activeTab = $(this).find('a').attr('href');
    $(activeTab).show();
    return false;
  });
    
});

document.addEventListener("alpine:init", () => {
  Alpine.data("gallery", alpineGallery);
});
 
Alpine.start();

/* pin card animation value ANIMACION CIFRAS*/
inView(".app-pin-item", (element) => {

  const countValue = element.querySelector(".app-pin-item-value");

  const finalValue = Number(element.dataset.value);

  const valueInDecimal = Boolean(element.dataset.decimal);


  const animateValue = (duration) => {

    if (countValue != null) {

      animate(0, finalValue, {

        duration: duration,

        ease: "circOut",

        onUpdate: (latest) => {

          countValue.innerHTML = !valueInDecimal 

            ? Math.round(latest).toLocaleString("en-US") 

            : latest.toLocaleString("en-US", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

        },

      });

    }

  };


  const handleButtonClick = (button) => {

    button.addEventListener("click", (event) => {

      if (button.classList.contains('swiper-button-disabled')) {

        //console.log('Button is disabled');

        return; // Exit the function early if the button is disabled

      }


      //console.log('Button is enabled');


      animateValue(0.5); // Call the animation function with the desired duration

    });

  };


  const buttonNext = document.querySelector("#cifras .swiper-button-next");

  const buttonPrev = document.querySelector("#cifras .swiper-button-prev");


  handleButtonClick(buttonNext);

  handleButtonClick(buttonPrev);


  animateValue(2); // Initial animation

});


/*historia*/
function animateInView(className, xStart) {
  inView(className, (element) => {
    animate(element, { 
      opacity: 1, 
      x: [xStart, 0] 
    }, { 
      duration: 1.4,
      easing: [0.17, 0.55, 0.75, 1],
    });
    return () => animate(element, { opacity: 1, x: [xStart, 0] });
  });
}
// Call the function for both classes
animateInView(".ruta", -100);
animateInView(".rutab", 100);
